import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PortalTypeIdEnum } from '../../../../models/enum/shared/portal-type-id.enum';
import { CSS_FORM_LIBRARY_URL } from '../../../../consts/consts';
import { SpousalWaiverTypeEnum } from '../../../../models/spousal-waivers/spousal-waiver-type.enum';
import { SubmissionSpousalWaiver } from '../../../../models/submissions/submission-spousal-waiver';

@Component({
  selector: 'app-mp-beneficiary-submission-spousal-waiver',
  templateUrl: './mp-beneficiary-submission-spousal-waiver.component.html',
  styleUrls: ['./mp-beneficiary-submission-spousal-waiver.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MpBeneficiarySubmissionSpousalWaiverComponent {
  @Input({ required: true }) spousalWaiver!: SubmissionSpousalWaiver;
  @Input({ required: true }) createdInPortalTypeId!: PortalTypeIdEnum;
  @Input({ required: true }) waiverTypeId!: SpousalWaiverTypeEnum;

  public navigateToExternalForms(): void {
    window.open(CSS_FORM_LIBRARY_URL, '_blank', 'noopener,noreferrer');
  }

  protected readonly PortalTypeIdEnum = PortalTypeIdEnum;
}
